import React from 'react'

import { DocumentReportArchiveList } from './components/DocumentReportArchiveList'

export const DocumentReportArchiveListPage = () => <DocumentReportArchiveList />
